import { Field } from "./field";
import { cr } from "fire-wind-water/core";
import api from "../services/api";

export class Radio extends Field {
  constructor(field) {
    super(field);
    const attr = [
      "listOptionType",
      "listDictId",
      "listLimitType",
      "listOptions",
      "options"
    ];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.displaySelectType = "RADIO";
    this.value = null;
    this.key = null;
    this.model = null;
    this.initOptions();
  }

  initOptions() {
    if (this.listOptionType === "DICT") {
      const info = {
        tenantId: this.tenantId,
        dicId: this.listDictId,
        format: "object"
      };
      api.dicParamsGetTree(info).subscribe(data => {
        if (data.result == 0) {
          this.setOptions(data.content[this.listDictId]);
        }
      });
    }
  }

  setOptions(data) {
    const arr = [];
    let isVal = false;
    cr.each(data, d => {
      if (this.model && d.name === this.model) {
        isVal = true;
      }
      arr.push({ optionId: d.paramId, optionValue: d.name });
    });
    this.listOptions = arr;
    if (!isVal) {
      this.setValue(null);
    }
  }

  setValue(ev, val) {
    if (cr.isArray(val)) {
      this.key = [];
      this.value = val;
      this.model = this.value ? this.value[0] : null;
    } else {
      this.key = val ? [val.optionId] : null;
      this.value = val ? [val.optionValue] : null;
      this.model = this.value ? this.value[0] : null;
    }
    this.dirty = ev && ev.target ? true : false;
    this.hasError();
    this.isError();
  }

  initValue(val) {
    this.setValue(null, val);
    this.dirty = false;
  }

  hasError() {
    this.setError();
    if (
      (!this.value || this.value.length === 0) &&
      parseInt(this.required) === 1
    ) {
      this.error.required = true;
    }
  }
}
